var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactHealthListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.5H12.5V0.5C12.5 0.367392 12.4473 0.240215 12.3536 0.146447C12.2598 0.0526785 12.1326 0 12 0H8.5C8.36739 0 8.24021 0.0526785 8.14645 0.146447C8.05268 0.240215 8 0.367392 8 0.5V3H5C4.86739 3 4.74021 3.05268 4.64645 3.14645C4.55268 3.24021 4.5 3.36739 4.5 3.5V6H2C1.86739 6 1.74021 6.05268 1.64645 6.14645C1.55268 6.24021 1.5 6.36739 1.5 6.5V10.5H1C0.867392 10.5 0.740215 10.5527 0.646447 10.6464C0.552678 10.7402 0.5 10.8674 0.5 11C0.5 11.1326 0.552678 11.2598 0.646447 11.3536C0.740215 11.4473 0.867392 11.5 1 11.5H13C13.1326 11.5 13.2598 11.4473 13.3536 11.3536C13.4473 11.2598 13.5 11.1326 13.5 11C13.5 10.8674 13.4473 10.7402 13.3536 10.6464C13.2598 10.5527 13.1326 10.5 13 10.5ZM9 1H11.5V10.5H9V1ZM5.5 4H8V10.5H5.5V4ZM2.5 7H4.5V10.5H2.5V7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactHealthListIcon);
export default __webpack_public_path__ + "static/media/contactHealthListIcon.5ef3483c.svg";
export { ForwardRef as ReactComponent };